
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/customization/theme-builder",
      function () {
        return require("private-next-pages/joy-ui/customization/theme-builder.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/customization/theme-builder"])
      });
    }
  